export enum IKnockStatusIcon {
  Star = 1,
  Heart = 2,
  Circle = 3,
  Cross = 4,

  SadFace = 5,
  NeutralFace = 6,
  HappyFace = 7,
  Paw = 8,

  Cloud = 9,
  Snowflake = 10,
  Dollar = 11,
  Rocket = 12,

  ThumbsUp = 13,
  ThumbsDown = 14,
  Check = 15,
  Warning = 16,

  Number1 = 17,
  Number2 = 18,
  Number3 = 19,
  Number4 = 20,
}

export interface IKnockStatus {
  id: string
  name: string
  color: string
  icon: IKnockStatusIcon
  isSystem?: boolean
  displayOrder?: number
}

export interface KnockStatusInput {
  id?: string
  name: string
  color: string
  icon: IKnockStatusIcon
}

export interface KnockStatusHistoryInput {
  id?: number | null
  knockStatusSettingsId?: string | null
  customReason?: string | null
  entityType: string
  entityId: number
  isActive: boolean
  serviceLocationId?: number
  knockStatusName?: string | null
  previousKnockStatusName?: string | null
  knockStatusLocationAddress?: KnockStatusLocationAddress
  contactLocationId?: number | null
  // True for a knock on an external (PestPac) pin — backend skips the standalone ContactLocation.
  isExternalPin?: boolean
}

export interface KnockStatusLocationDto {
  id: number
  knockStatusSettingsId: number
  street1: string
  street2: string
  city: string
  stateAbbreviation: string
  postalCode: string
  county: string
  country: string
  longitude: number | null
  latitude: number | null
}

export interface KnockStatusHistoryRecord {
  id: number
  knockStatusSettingsId: number | null
  knockStatusSettingsName: string | null
  customReason: string | null
  knockStatusLocationId: number
  location: KnockStatusLocationDto
  isActive: boolean
  createdBy: string
  createdByName: string
  createdTime: string
  updatedBy: string
  updatedDate: string | null
}

export interface UpdateKnockStatusHistoryInput {
  customReason: string | null
  knockStatusName: string | null
  previousKnockStatusName: string | null
  entityType: string
  entityId: number
}

export interface KnockStatusLocationAddress {
  street1: string
  street2: string
  city: string
  stateAbbreviation: string
  postalCode: string
  country: string
  latitude: number
  longitude: number
  knockStatusLocationId?: number
}

export interface KnockStatusLocationBaseInput {
  id?: number | null
  knockStatusSettingsId?: string | null
  customReason?: string | null
  knockStatusSettingName?: string | null
  isActive: boolean
  knockStatusLocationAddress?: KnockStatusLocationAddress
  // See KnockStatusHistoryInput.isExternalPin.
  isExternalPin?: boolean
}

// Mirrors backend KnockStatusDetailsDto — the shared response shape returned by
// both POST /KnockStatusLocations and PUT /KnockStatusLocations as of SH-1176.
export interface KnockStatusDetails {
  knockStatusLocationId: number
  knockStatusSettingsId: number
  knockStatusSettingsName: string
  knockStatusSettingsColor: string
  knockStatusSettingsIcon: number
  mostRecentNote: string | null
  latitude: number | null
  longitude: number | null
  createdTime: string
  createdByName: string
  knockStatusCount: number
}

export interface KnockStatusLocationByCoordinatesResult {
  knockStatusLocationId: number
  hasHistory: boolean
  activeKnockStatusSettingName: string | null
  activeCustomReason: string | null
  // SH-1307 -- full history (not just the active entry), so a location whose
  // active status was deleted from Settings can still show "View Knock Status
  // History" and open it.
  history: KnockStatusHistoryRecord[]
}
